import { useState, useEffect } from 'react';
import { Trash, Edit } from 'lucide-react';
import apiClient from "../Api/apiConfig";
import { useAuth } from "../lib/auth";
import Modal from "../components/Modalusergrivevance"; // ✅ Importation du modal

// Liste des statuts
const statuses = [
  { value: "new", label: "Nouveau" },
  { value: "en cours", label: "En cours" },
  { value: "résolu", label: "Résolu" },
  { value: "fermé", label: "Fermé" }
];

export default function UserGrievancesPage() {
  const [grievances, setGrievances] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editingGrievance, setEditingGrievance] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // ✅ État pour ouvrir/fermer le modal
  const { user } = useAuth();

  // 📌 Récupérer les doléances de l'utilisateur
  useEffect(() => {
    const fetchUserGrievances = async () => {
      try {
        if (!user?.email) return;
        const response = await apiClient.get("/grievances")
        const userGrievances = response.data.filter(g => g.user_email?.toLowerCase() === user.email.toLowerCase());
        setGrievances(userGrievances);
      } catch (err) {
        console.error("Erreur lors de la récupération des doléances :", err);
        setError("Impossible de charger vos doléances.");
      } finally {
        setLoading(false);
      }
    };
    fetchUserGrievances();
  }, [user]);

  // 📌 Ouvrir le modal avec les données de la doléance
  const handleEdit = (grievance) => {
    setEditingGrievance({ ...grievance });
    setIsModalOpen(true);
  };

  // 📌 Mettre à jour l'état lors de la modification
  const handleEditChange = (e) => {
    setEditingGrievance({ ...editingGrievance, [e.target.name]: e.target.value });
  };

  // 📌 Sauvegarder la modification
  const saveEdit = async () => {
    try {
      await apiClient.put(`/grievances/${editingGrievance.id}`, {
        title: editingGrievance.title.trim(),
        description: editingGrievance.description.trim(),
        statuts: editingGrievance.statuts.trim(),
      });

      setGrievances(grievances.map(g => (g.id === editingGrievance.id ? editingGrievance : g)));
      setIsModalOpen(false);
      setEditingGrievance(null);
      alert("Doléance modifiée avec succès.");
    } catch (err) {
      console.error("Erreur lors de la modification :", err);
      alert("Une erreur est survenue.");
    }
  };

  // 📌 Supprimer une doléance
  const deleteGrievance = async (id) => {
    if (!window.confirm("Voulez-vous vraiment supprimer cette doléance ?")) return;

    try {
      await apiClient.delete(`/grievances/${id}`);
      setGrievances(grievances.filter(g => g.id !== id));
    } catch (err) {
      console.error("Erreur lors de la suppression :", err);
      alert("Une erreur est survenue.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-2xl font-semibold text-gray-900">Mes doléances</h1>

        {loading ? (
          <p className="p-4 text-center text-gray-500">Chargement des données...</p>
        ) : error ? (
          <p className="p-4 text-center text-red-500">{error}</p>
        ) : grievances.length === 0 ? (
          <p className="p-4 text-center text-gray-600">Vous n'avez pas de doléances.</p>
        ) : (
          <div className="mt-4 bg-white shadow rounded-lg overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-300">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Référence</th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Titre</th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Description</th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Statuts</th>
                  <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {grievances.map((grievance) => (
                  <tr key={grievance.id}>
                    <td className="px-3 py-4 text-sm">{grievance.reference}</td>
                    <td className="px-3 py-4 text-sm">{grievance.title}</td>
                    <td className="px-3 py-4 text-sm">{grievance.description}</td>
                    <td className="px-3 py-4 text-sm">{grievance.statuts}</td>
                    <td className="px-3 py-4 text-sm flex space-x-2">
                      <button onClick={() => handleEdit(grievance)}><Edit /></button>
                      <button onClick={() => deleteGrievance(grievance.id)}><Trash /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={saveEdit} grievance={editingGrievance} handleEditChange={handleEditChange} statuses={statuses} />
    </div>
  );
}
